/**
 * Loading indicator for map layers and operations
 * Shows when layers are being fetched or operations are in progress
 */
import React from 'react';

const LoadingIndicator = ({ loading, message, blocking = false }) => {
  if (!loading) return null;

  const content = (
    <div style={{
      position: 'absolute',
      top: '80px',
      right: '20px',
      background: 'rgba(255, 255, 255, 0.95)',
      padding: '12px 20px',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
      zIndex: blocking ? 10000 : 1000,
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      fontSize: '14px',
      fontWeight: '500',
      color: '#333'
    }}>
      <div style={{
        width: '20px',
        height: '20px',
        border: '3px solid #f3f3f3',
        borderTop: '3px solid #1976d2',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }} />
      <span>{message}</span>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );

  // If blocking, add a full-screen overlay to prevent interaction
  if (blocking) {
    return (
      <>
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.3)',
          zIndex: 9999,
          cursor: 'wait'
        }} />
        {content}
      </>
    );
  }

  return content;
};

export default LoadingIndicator;
